module.exports = __webpack_public_path__ + "static/dpc-logo-mini-b95da6980479b9bf724373b1825ac758.png";